/*
 * @Author: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @Date: 2023-11-11 10:48:10
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2023-12-28 09:48:18
 * @FilePath: \合联\oms\src\api\analysis\tm_track.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
let name = '/report/tracker/'

export const apis = buildApi({
  get: [],
  post: ['/shipments/timeout', name + '/tm&list']
})